export function getStringFromRecord(
  record: Record<string, unknown>,
  key: string,
): string | undefined {
  const value = record[key];

  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmedValue = value.trim();
  return trimmedValue || undefined;
}

export function getFullNameFromUnknown(value: unknown): string | undefined {
  if (!value || typeof value !== 'object') {
    return undefined;
  }

  const record = value as Record<string, unknown>;

  const directName =
    getStringFromRecord(record, 'fullName') ??
    getStringFromRecord(record, 'displayName') ??
    getStringFromRecord(record, 'name');

  if (directName) {
    return directName;
  }

  const firstName = getStringFromRecord(record, 'firstName') ?? '';
  const lastName = getStringFromRecord(record, 'lastName') ?? '';
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || undefined;
}
